'use client';

import dynamic from 'next/dynamic';

export const DynamicHeader = dynamic(
  () => import('./Header').then(mod => mod.Header),
  { ssr: false }
);
